let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("heNxp")).then(() => parcelRequire('i9zBn'));